import { render, staticRenderFns } from "./SortMobile.vue?vue&type=template&id=f77a36aa&scoped=true&"
import script from "./SortMobile.vue?vue&type=script&lang=js&"
export * from "./SortMobile.vue?vue&type=script&lang=js&"
import style0 from "./SortMobile.vue?vue&type=style&index=0&id=f77a36aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77a36aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f77a36aa')) {
      api.createRecord('f77a36aa', component.options)
    } else {
      api.reload('f77a36aa', component.options)
    }
    module.hot.accept("./SortMobile.vue?vue&type=template&id=f77a36aa&scoped=true&", function () {
      api.rerender('f77a36aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/Step2Mobile/SortMobile.vue"
export default component.exports